module.exports = __webpack_public_path__ + "img/smart.e1b0733e.png";